var map = {
	"./ASSESS/ASSESS-1/examMockConfig": 32545,
	"./ASSESS/ASSESS-1624/examMockConfig": 86197,
	"./ASSESS/ASSESS-554/examMockConfig": 46098,
	"./ASSESS/ASSESS-557/examMockConfig": 2426,
	"./ASSESS/ASSESS-595/examMockConfig": 43219,
	"./ASSESS/ASSESS-596/examMockConfig": 92636,
	"./ASSESS/ASSESS-597/examMockConfig": 42665,
	"./ASSESS/ASSESS-598/examMockConfig": 21354,
	"./ASSESS/ASSESS-609/examMockConfig": 73727,
	"./ASSESS/ASSESS-958/examMockConfig": 58322,
	"./language_assessment/examMockConfig": 18763,
	"./template/examMockConfig": 36652,
	"./testbuilder/examMockConfig": 37249
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97748;